var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StoreForm',{attrs:{"title":_vm.$t('store.create_btn'),"action":_vm.createStore},on:{"success":_vm.handleSuccess}})
}
var staticRenderFns = []

export { render, staticRenderFns }